import { Fade, IconButton, Modal } from '@mui/material';
import { MdClose } from 'react-icons/md';
import ReactDOM from 'react-dom';
import React, { FunctionComponent } from 'react';

import LoginForm from "../LoginForm/LoginForm";
import RegisterCard from "../RegisterCard/RegisterCard";
import useStyles from "./LoginModalStyles";

interface Props {
    isShown: boolean;
    hide: () => void;
    isMobile?: boolean;
};

export const LoginRegisterModal: FunctionComponent<Props> = ({
    isShown,
    hide,
    isMobile = false
}) => {
    const { classes } = useStyles();
    const [isLoginModal, setIsLoginModal] = React.useState<boolean>(true);

    const handleHide = (hideModal: boolean) => {
        setIsLoginModal(true);
        if (hide) hide();
    }

    const handleIsLogin = (isLogin) => {
        setIsLoginModal(isLogin);
    }

    const modal = (
        <Modal
            id={"modal-window"}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={isShown}
            className={classes.modal}
            onClose={handleHide}>
            <Fade in={isShown}>
                <div>
                    <div className="pb-auth-card">
                        <IconButton aria-label="Close" className="pb-auth-close" onClick={() => handleHide(true)}>
                            <MdClose size={20} />
                        </IconButton>
                        {isLoginModal ?
                            <LoginForm navigateOnLogin={false} isLogin={(isLogin) => handleIsLogin(isLogin)} isMobile={isMobile} handleHide={hide} />
                            : <RegisterCard isLogin={(isLogin) => handleIsLogin(isLogin)} />}
                    </div>
                </div>
            </Fade>
        </Modal>
    );
    return isShown ? ReactDOM.createPortal(modal, document.body) : null;
}
export default LoginRegisterModal;